import React, {Component, Fragment} from "react";
import {ICDBPageProps } from "../../../utils/ICDBPageProps";
import LoadingPage from "../../LoadingPage";
import {DurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import ProcessorComparisonResult from "../../../models/ProcessorComparisonResult";
import ProcessorDiffViewer from "../../ProcessorDiffViewer";


interface MailroomBulkComparisonItemPageProps extends ICDBPageProps
{
    instanceId: string;
    itemInstanceId: string;
}

interface MailroomBulkComparisonItemPageState
{
    itemWithResult?: {itemInstance: DurableFunctionInstance,comparisonResult: ProcessorComparisonResult}
    loading: boolean;
}


export default class MailroomBulkComparisonItemPage extends Component<MailroomBulkComparisonItemPageProps, MailroomBulkComparisonItemPageState> {
    
    constructor(props: MailroomBulkComparisonItemPageProps) {
        super(props);

        this.state = {
            loading: false
        };
    }

    public async componentDidMount()
    {
        this.setState({
            loading: true
        });
        
        try
        {
            const itemWithResult = await this.props.apiService.getBulkProcessorComparisonItemWithResult(this.props.instanceId, this.props.itemInstanceId);
            this.setState({
                itemWithResult
            });
        }
        catch (e)
        {
            this.props.messageBar.error(`Failed to load : ${e}`);
        }
        
        this.setState({
            loading: false
        });
    }

    async componentDidUpdate(prevProps: Readonly<MailroomBulkComparisonItemPageProps>, prevState: Readonly<MailroomBulkComparisonItemPageState>, snapshot?: any): Promise<void> {
    }
    
    public render()
    {
        if(this.state.loading)
        {
            return <LoadingPage/>;
        }
        
        if(!this.state.itemWithResult?.comparisonResult)
        {
            return (<span>No comparison result found</span>);
        }
        
        return (
            <Fragment>
                <ProcessorDiffViewer result={this.state.itemWithResult!.comparisonResult}/>
            </Fragment>
        );
    }
}